import { challengePaths } from "@/lib/challengePaths";

export const organizeCompletedChallengesByPath = (
  dbCompletedChallenges: any[],
  userId: string
) => {
  const pathData: { [pathId: string]: any } = {};

  challengePaths.forEach((path) => {
    const pathChallenges: any[] = [];
    let totalPathScore = 0;

    const pathChallengeIds = path.stages.flatMap((stage) =>
      stage.challenges.map((challenge) => challenge.id)
    );

    const completedInThisPath = dbCompletedChallenges.filter((completed) =>
      pathChallengeIds.includes(completed.challenge_id)
    );

    completedInThisPath.forEach((completed) => {
      pathChallenges.push(completed);
      totalPathScore += completed.points_earned || 0;
    });

    const pathKey = `path_${path.id}_${userId}`;
    const pathSummary = {
      pathId: path.id,
      userId: userId,
      completedChallenges: pathChallenges,
      totalScore: totalPathScore,
      completedCount: pathChallenges.length,
      lastUpdated: new Date().toISOString(),
    };

    localStorage.setItem(pathKey, JSON.stringify(pathSummary));
    pathData[path.id] = pathSummary;
  });

  return pathData;
};
